import { TOption } from "../../Components/Select";
import { IFirmware, TDeviceType } from "./types";

export type TFirmwareOption = TOption<number>;
export const getFirmwareOptions = (
  firmwares: IFirmware[],
  device_type: TDeviceType,
): TFirmwareOption[] => {
  const result = firmwares
    .map(function (firmware): TFirmwareOption {
      return { label: firmware.version, value: firmware.id };
    })
    .sort(function (a: TFirmwareOption, b: TFirmwareOption) {
      if (a.label && b.label) {
        return a.label.localeCompare(b.label);
      }
      return a.value - b.value;
    })
    .reverse();
  return result;
};
